export const DESTINATION_COUNTRIES = [
  { value: "Austria", label: "Austria", isoCode: "AT" },
  { value: "Belgium", label: "Belgium", isoCode: "BE" },
  { value: "Bulgaria", label: "Bulgaria", isoCode: "BG" },
  { value: "Czech Republic", label: "Czech Republic", isoCode: "CZ" },
  { value: "Cyprus", label: "Cyprus", isoCode: "CY" },
  { value: "Denmark", label: "Denmark", isoCode: "DK" },
  { value: "Estonia", label: "Estonia", isoCode: "EE" },
  { value: "France", label: "France", isoCode: "FR" },
  { value: "Finland", label: "Finland", isoCode: "FI" },
  { value: "Germany", label: "Germany", isoCode: "DE" },
  { value: "Greece", label: "Greece", isoCode: "EL" },
  { value: "Hungary", label: "Hungary", isoCode: "HU" },
  { value: "Ireland", label: "Ireland", isoCode: "IE" },
  { value: "Italy", label: "Italy", isoCode: "IT" },
  { value: "Latvia", label: "Latvia", isoCode: "LV" },
  { value: "Lithuania", label: "Lithuania", isoCode: "LT" },
  { value: "Luxembourg", label: "Luxembourg", isoCode: "LU" },
  { value: "Malta", label: "Malta", isoCode: "MT" },
  { value: "Netherlands", label: "Netherlands", isoCode: "NL" },
  { value: "Poland", label: "Poland", isoCode: "PL" },
  { value: "Portugal", label: "Portugal", isoCode: "PT" },
  { value: "Romania", label: "Romania", isoCode: "RO" },
  { value: "Spain", label: "Spain", isoCode: "ES" },
  { value: "Slovenia", label: "Slovenia", isoCode: "SI" },
  { value: "Slovakia", label: "Slovakia", isoCode: "SK" },
  { value: "Sweden", label: "Sweden", isoCode: "SE" },
  { value: "United Kingdom", label: "United Kingdom", isoCode: "UK" },
];

export const QUANTITY_UNITS = [
  { value: "", label: "None" },
  { value: "Kg", label: "Kg" },
  { value: "MT", label: "MT" },
];

export const VARIANT_OPTIONS = [
  { value: "Normal", label: "Normal" },
  { value: "Organic", label: "Organic" },
  { value: "Loose", label: "Loose" },
];

export const SAMPLE_TYPES = [
  { value: "Whole", label: "Whole" },
  { value: "Powder", label: "Powder" },
];

export const SAMPLING_TYPES = [
  { value: "Composite Sampling", label: "Composite Sampling" },
  { value: "Code-wise Sampling", label: "Code-wise Sampling" },
];

export const REJECTION_REASONS = [
  { value: "Sample Not Available", label: "Sample Not Available" },
  { value: "Wrong Sample/Out of Scope Purchased", label: "Wrong Sample/Out of Scope Purchased" },
  { value: "Sample Not Collected by Sampler", label: "Sample Not Collected by Sampler" },
  { value: "Sample Collected but Not Submitted", label: "Sample Collected but Not Submitted" },
  { value: "Incorrect Variant Purchased", label: "Incorrect Variant Purchased" },
  { value: "Incorrect Commodity Purchased", label: "Incorrect Commodity Purchased" },
  { value: "Sample Lost in Transit", label: "Sample Lost in Transit" },
  { value: "Sample Damaged in Transit", label: "Sample Damaged in Transit" },
  { value: "Insufficient Sample Quantity", label: "Insufficient Sample Quantity" },
  { value: "Expired Sample", label: "Expired Sample" },
  { value: "Project Closed", label: "Project Closed" },
  { value: "Wrong Order Created", label: "Wrong Order Created" },
  { value: "Others", label: "Others" },
];

// Map status labels to their keys in orderStatusFlow
export const statusLabelToKey = {
  Pending: "pending",
  Booked: "booked",
  "In Review": "inReview",
  "Need Correction": "needCorrection",
  "Ready for Pickup": "readyForPickup",
  "Out for Pickup": "outForPickup",
  "Delivered to Lab": "deliveredToLab",
  "Received at Lab": "receivedAtLab",
  "Under Testing": "underTesting",
  "Report Uploaded": "reportUploaded",
  Completed: "completed",
  Regret: "regret",
  "Rejected by Lab": "rejectedByLab",
  "Not Found": "notFound",
  "Under Dispute": "underDispute",
  "Dispute Resolved": "disputeResolved",
  "Order Correction": "orderCorrection",
};